import { z } from 'zod'

export const CustomerDetailsSchema = z.object({
  id: z.string().optional(),
  firstName: z.string().nullable().optional(),
  lastName: z.string().nullable().optional(),
  phoneNumber: z.string().nullable().optional(),
  email: z
    .string()
    .min(8, { message: 'Email must be at least 8 characters long' })
})

export const AddressSchema = z.object({
  address1: z.string().min(1, { message: 'Address 1 cannot be empty' }),
  address2: z.string().nullable().optional(),
  city: z.string().min(1, { message: 'City cannot be empty' }),
  zip: z.string().min(1, { message: 'Postal code cannot be empty' }),
  zoneCode: z.string().nullable().optional(),
  id: z.string(),
  firstName: z.string().min(1, { message: 'First Name cannot be empty' }),
  lastName: z.string().min(1, { message: 'Last Name cannot be empty' })
})

export type AddressData = z.infer<typeof AddressSchema>

export type CustomerDetailsData = z.infer<typeof CustomerDetailsSchema>
